import { render, staticRenderFns } from "./GameNotFound.vue?vue&type=template&id=41ef7134&"
import script from "./GameNotFound.vue?vue&type=script&lang=js&"
export * from "./GameNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports